import React, { useState, useEffect, useRef } from "react";

import {Button, TextField, InputAdornment, Modal, Container, Autocomplete, IconButton, Stack} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import FaxIcon from '@mui/icons-material/LocalPrintshop';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import UploadIcon from '@mui/icons-material/CloudUpload';
import LinkIcon from '@mui/icons-material/Link';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import LoadingButton from "@mui/lab/LoadingButton";

import config from '../../../hoa-config';

import '../../hoa-styles.scss';
import '../hoa-municipality-styles.scss'
import PDFsContainerComponent from "../../../components/pdf-container-component/hoa-pool-access-form-pdf-container";
import dashboardServices from '../../../services/hoa-dashboard-api-service';
import CustomTextField from '../../../components/custom-text-field/custom-text-field';

interface MunicipalitiesBasicFormProps {
    view: any;
    state: any;
    setState: any;
    responsiveHeight: number;
    checkError : boolean;
    isEmailValid: any;
    isFaxValid: any;
    isPhoneValid: any;
    isValidHttpUrl:any;
    files : any;
    setFiles: any;
    muncipality: any;
    updateMuncipalityData: any;
    updateSelectedValues: any;
    isUpdating : boolean;
}


export default function MunicipalitiesBasicForm(props : MunicipalitiesBasicFormProps) {
    const {view, state, setState, checkError, files, setFiles, muncipality, updateMuncipalityData, updateSelectedValues, isUpdating} = props;
    const [emailValid, setEmailValid] = useState(null);
    const [phoneValid, setPhoneValid] = useState(null);
    const [faxValid, setFaxValid] = useState(null);
    const [currentZip, setCurrentZip] = useState('');
    const [addedZips, setAddedZips] = useState([]);
    const [open, toggleOpen] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState({});
    const [documentName, setDocumentName] = useState('');
    const uploadButton1 = useRef(null);
    const uploadButton2 = useRef(null);
    useEffect(()=>{
        setEmailValid(props.isEmailValid(state.email as string));
        setPhoneValid(props.isPhoneValid(state.phone as string));
        setFaxValid(props.isFaxValid(state.fax as string))
    })
    useEffect(() => {
        if(state.zip != ""){
            setAddedZips(state.zip.split(','))
        }
    },[state.zip])

    const handleChange = (value: string, key: string) => {
        if(key === 'email'){
            setEmailValid(props.isEmailValid(value as string));
        } else if(key === 'phone'){
            setPhoneValid(props.isPhoneValid(value as string));
        }
        else if(key === "fax"){
            setFaxValid(props.isFaxValid(value as string))
        }
        let tempState : any = state;
        tempState[key] = value;
        setState({...tempState});
    }

    const addZip = ()=>{
        let tempState : any = {...state};
        if(!addedZips.includes(currentZip)){
            let zips = addedZips;
            zips.push(currentZip);
            setAddedZips(zips);
            tempState.zip = concatZips(zips);
            setState(tempState);
        }
        setCurrentZip('');
    }

    const removeZip = (zip: string) => {
        let tempState : any = {...state};
        const zips = addedZips.filter((item:string)=> {return item !== zip});
        setAddedZips(zips);
        tempState.zip = concatZips(zips);
        setState(tempState);
    }

    const concatZips = (zips: string[]) =>{
        let zipString = '';
        zips.map((zip: string, index: number)=>{
            zipString+=zip;
            if(index < zips.length -1){
                zipString += ", ";
            }
        })
        return zipString;
    }

    const handleClose = () => {
		toggleOpen(false);
	};

    const deleteClick = (document: string, name: any) => {
        setDocumentName(document);
		setSelectedDocument(name);
		toggleOpen(!open);
	}

    return (
        <div style={{ justifyContent: 'center', fontSize: '20px', width: "100%", height: "100%", boxSizing: "border-box" }}>
            <div style={{ display: 'flex', flexDirection: 'column', border: "1px solid #E8E8E8", borderRadius: "4px", width: "100%" }}>
            <DeleteAttachmentComp
                open={open}
                toggleOpen={toggleOpen}
                handleClose={handleClose}
                documentName={documentName}
                state={state}
                setState={setState}
                files={files}
                setFiles={setFiles}
                selectedDocument={selectedDocument}
                setSelectedDocument={setSelectedDocument}
                muncipality={muncipality}
                updateMuncipalityData={updateMuncipalityData}
                updateSelectedValues={updateSelectedValues}
			/>
                <div style={{ height:(window.innerHeight - props.responsiveHeight) ,  overflow:'scroll' }} className = "add-municipality-form-container">
                    <div className ="left-form-container">
                        <div className="sub-title-text">Municipality Information</div>
                        <div style={{ display: "flex", marginTop: "24px", justifyContent: "space-between" }}>
                            <TextField style={{ width: "50%" }} variant="standard" label="Name" required error = {checkError && !state.name} value={state.name}
                                onChange={(e)=>{handleChange(e.target.value, "name")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}} disabled={isUpdating}/>
                            <Autocomplete
                                ListboxProps={{ style: { maxHeight: "200px"} }}
                                style={{ width: "40%", height:"62px", boxSizing:"border-box"}}
                                disablePortal
                                value={state.market || ''}
                                options={config.marketOptions}
                                onChange={(e, v) => {
                                    handleChange(v, "market")
                                }}
                                disabled={isUpdating}
                                renderInput={(params: any) => <TextField variant="standard" error = {checkError && !state.market} required name='state' style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Market"/>}
                            />
                        </div>
                        <div style={{ display: "flex", marginTop: "24px", justifyContent: "space-between" }}>
                            <TextField style={{ width: "45%" }} variant="standard" label="City" error = {checkError && !state.city} value={state.city} required
                                onChange={(e)=>{handleChange(e.target.value, "city")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}} disabled={isUpdating}/>
                            <Autocomplete
                                ListboxProps={{ style: { maxHeight: "200px"} }}
                                style={{ width: "45%", height:"62px", boxSizing:"border-box"}}
                                disablePortal
                                value={state.state || ''}
                                options={config.stateOptions}
                                onChange={(e, v) => {
                                    handleChange(v, "state")
                                }}
                                disabled={isUpdating}
                                renderInput={(params: any) => <TextField variant="standard" error = {checkError && !state.state} required name='state' style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="State"/>}
                            />
                        </div>
                        <div style={{  marginTop: "24px", display:"flex", flexDirection:"column"}}>
                            <TextField style={{ width: "60%", marginBottom:"5px" }} variant="standard" label="Zip *" error = {checkError && !state.zip} value={currentZip}
                                onChange={(e)=>{setCurrentZip(e.target.value)}} InputLabelProps={{style:{fontSize:"14px"}}}
                                onKeyDown={(e)=>{
                                    if (e.key === "Enter") {
                                        addZip()
                                }}}
                                InputProps={{style:{ padding:"7px 0px"}}}/>
                                <div style={{display:"flex", flexWrap:"wrap"}}>
                                {
                                    addedZips.length > 0 &&
                                    addedZips.map((zip: string, index: number)=>{
                                        return (
                                            <div className="amenityIconBox" key={zip + '-' + index}>
                                                <span>{zip}</span>
                                                <IconButton onClick={() => { removeZip(zip) }} style={{ padding: "0px" }}>
                                                    <CloseIcon />
                                                </IconButton>
                                            </div>
                                        )
                                    })
                                }
                                </div>
                        </div>
                        <div style={{  marginTop: "24px"}}>
                            <TextField style={{ width: "100%" }} variant="standard" label="Municipality Office Address" error={checkError && !state.officeAddress} value={state.officeAddress} required
                                onChange={(e)=>{handleChange(e.target.value, "officeAddress")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}}/>
                        </div>
                        <div style={{ display: "flex", marginTop: "24px", justifyContent: "space-between" }}>
                            <TextField variant="standard" style={{ width: "45%", }} value={state.phone} error={checkError && !phoneValid} helperText={checkError && !phoneValid ? 'Invalid number format' : ''}
                                onChange={(e)=>{handleChange(e.target.value, "phone")}} label="Phone Number" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                        <InputAdornment position="end">
                                            <LocalPhoneIcon />
                                        </InputAdornment>
                            )}}/>
                            <TextField variant="standard" style={{ width: "45%", }} value={state.email} error={checkError && !emailValid} helperText={checkError && !emailValid ? 'Invalid email format' : ''}
                                onChange={(e)=>{handleChange(e.target.value, "email")}} label="Email Address" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                        <InputAdornment position="end">
                                            <MailOutlineIcon />
                                        </InputAdornment>
                            )}}/>
                        </div>
                        <div style={{  marginTop: "24px"}}>
                            <TextField variant="standard" style={{ width: "45%", }} value={state.fax} error={checkError && !faxValid} helperText={checkError && !faxValid ? 'Invalid fax format' : ''}
                                onChange={(e)=>{handleChange(e.target.value, "fax")}} label="Fax" InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                        <InputAdornment position="end">
                                            <FaxIcon />
                                        </InputAdornment>
                            )}}/>
                        </div>
                        <div style={{  marginTop: "24px"}}>
                            <TextField style={{ width: "100%" }} required variant="standard" label="Website" error = {checkError && (!state.website || !props.isValidHttpUrl(state.website))} value={state.website}
                                onChange={(e)=>{handleChange(e.target.value, "website")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                helperText={checkError && !props.isValidHttpUrl(state.website) ? 'Invalid url format' : ''}
                                InputProps={{
                                    style:{ padding:"7px 0px"},
                                    endAdornment :(
                                        <InputAdornment position="end">
                                            <LanguageIcon />
                                        </InputAdornment>
                            )}}/>
                        </div>
                    </div>

                    {/*RIGHT*/}
                    <div className ="right-form-container">
                        <div className="sub-title-text" style={{marginBottom:"24px"}}>Registration Information</div>
                        <div style={{fontSize:"14px", lineHeight:"16px"}}>Tenant or Lease Registration Form</div>
                        <div className="helperText">Please upload necessary document and hyperlink.</div>
                        <p>
                            <Button style={{ borderColor: '#E49B0F' }} startIcon={<UploadIcon color="primary"/>} variant="outlined" onClick={()=>{uploadButton1.current.click()}}>
                                Upload Document
                                <input ref={uploadButton1} hidden multiple type='file' accept="application/pdf,application/vnd.ms-excel, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    onChange={(e) => {
                                        setFiles({...files, tenantLeaseRegistrationFormUrl: [...files.tenantLeaseRegistrationFormUrl, ...Array.from(e.target.files)]}) 
                                    }}
                                />
                            </Button>
                        </p>
                        {
                            files.tenantLeaseRegistrationFormUrl?.length > 0 ?
                            <>
                            <p className="helperText">Selected File :</p>
                            {
                                Array.from(files.tenantLeaseRegistrationFormUrl).map((file : any, index: number)=>{
                                    return   <PDFsContainerComponent document={`tenantLeaseRegistrationFormUrl`} deleteClick={deleteClick} view={view} key={index} file={file} />
                                })
                            }
                            </>
                            : ''
                        }
                        {
                            state.tenantLeaseRegistrationFormUrl?.length > 0 ?
                            <>
                            <p className="helperText">Uploaded File :</p>
                            {
                                Array.from(state.tenantLeaseRegistrationFormUrl).map((file : any, index: number)=>{
                                    return   <PDFsContainerComponent document={`tenantLeaseRegistrationFormUrl`} deleteClick={deleteClick} view={view} key={index} file={file} />
                                })
                            }
                            </>
                            : ''
                        }
                        <CustomTextField variant="standard" style={{ width: "90%" }} value={state.registrationResolutionForm}
                            onChange={(e) => { handleChange(e.target.value, "registrationResolutionForm") }} label="Hyper Link" InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                            helperText={state.registrationResolutionForm.trim().length > 0 && checkError && !props.isValidHttpUrl(state.registrationResolutionForm as string) ? 'Invalid url format' : ''}
                            error={state.registrationResolutionForm.trim().length > 0 && checkError && !props.isValidHttpUrl(state.registrationResolutionForm as string)}
                            InputProps={{
                                style: { padding:"7px 0px" },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <LinkIcon />
                                    </InputAdornment>
                        )}} />

                        <div style={{width:"100%", height:"2px", borderTop:"2px solid #E8E8E8", margin:"32px 0px"}}/>

                        <div style={{marginTop:"36px", fontSize:"14px", marginBottom:"10px", lineHeight:"16px"}}>Registration Requirements</div>
                        <CustomTextField style={{ width: "75%", marginBottom:"24px"}} variant="outlined" value={state.registrationRequirements}
                            onChange={(e) => { handleChange(e.target.value, "registrationRequirements") }} label="Write here..." multiline
                            InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} InputProps={{ style: { minHeight:"106px" } }}
                        />

                        <div style={{width:"100%", height:"2px", borderTop:"2px solid #E8E8E8", margin:"32px 0px"}}/>

                        <div style={{fontSize:"14px", lineHeight:"16px"}}>County's or Municipality's Renewal Form</div>
                        <div className="helperText">Please upload necessary document and hyperlink.</div>
                        <p>
                            <Button style={{ borderColor: '#E49B0F' }} startIcon={<UploadIcon color="primary"/>} variant="outlined" onClick={()=>{uploadButton2.current.click()}}>
                                Upload Document
                                <input ref={uploadButton2} multiple hidden type='file' accept="application/pdf,application/vnd.ms-excel"
                                    onChange={(e) => {
                                        setFiles({...files, countyOrMunicipalityRenewalForm: [...files.countyOrMunicipalityRenewalForm, ...Array.from(e.target.files)]}) 
                                    }}
                                />
                            </Button>
                        </p>
                        {
                            files.countyOrMunicipalityRenewalForm?.length > 0 ?
                            <>
                            <p className="helperText">Selected File :</p>
                            {
                                Array.from(files.countyOrMunicipalityRenewalForm).map((file : any, index: number)=>{
                                    return   <PDFsContainerComponent document={`countyOrMunicipalityRenewalForm`} deleteClick={deleteClick} view={view} key={index} file={file} />
                                })
                            }
                            </>
                            : ''
                        }
                        {
                            state.countyOrMunicipalityRenewalForm?.length > 0 ?
                            <>
                            <p className="helperText">Uploaded File :</p>
                            {
                                Array.from(state.countyOrMunicipalityRenewalForm).map((file : any, index: number)=>{
                                    return   <PDFsContainerComponent document={`countyOrMunicipalityRenewalForm`} deleteClick={deleteClick} view={view} key={index} file={file} />
                                })
                            }
                            </>
                            : ''
                        }
                        <CustomTextField variant="standard" style={{ width: "90%" }} value={state.ownerRenewalForm}
                            onChange={(e) => { handleChange(e.target.value, "ownerRenewalForm") }} label="Hyper Link" InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                            helperText={state.ownerRenewalForm.trim().length > 0 && checkError && !props.isValidHttpUrl(state.ownerRenewalForm as string) ? 'Invalid url format' : ''}
                            error={state.ownerRenewalForm.trim().length > 0 && checkError && !props.isValidHttpUrl(state.ownerRenewalForm as string)}
                            InputProps={{
                                style: { padding:"7px 0px" },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <LinkIcon />
                                    </InputAdornment>
                        )}} />

                        <div style={{marginTop:"36px", fontSize:"14px", marginBottom:"10px", lineHeight:"16px"}}>Renewal Instructions</div>
                        <CustomTextField style={{ width: "75%", marginBottom:"24px"}} variant="outlined" value={state.renewalInstructions}
                            onChange={(e) => { handleChange(e.target.value, "renewalInstructions") }} label="Write here..." multiline
                            InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} InputProps={{ style: { minHeight:"106px" } }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const DeleteAttachmentComp = ({
	open,
	toggleOpen,
	handleClose,
    selectedValues,
    selectedDocument,
    setSelectedDocument,
    documentName,
    state,
    setState,
    files,
    setFiles,
    muncipality,
    updateMuncipalityData,
    updateSelectedValues
}: any) => {
	const [error, setError] = useState({ link: false, files: false });
	const [isLoading, setLoading] = useState(false);
    const doc = {
        name: selectedDocument.fileName
    }
	const handleDelete = async () => {
        setLoading(true);
        if(files && files[documentName].length){
            const arr = files[documentName].filter((item: any) => {
                return item.name != selectedDocument.name
            })
            setFiles({...files, [documentName]: arr})
            setLoading(false);
            handleClose();
            return;
        }
		let arr = state[documentName].filter((item: any) => {
			return item.fileName != selectedDocument.fileName;
		});
        setState({...state, [documentName]: arr})
        await dashboardServices.deleteMunicipalityDocuments(doc, state.objectId, documentName.substring(0, documentName.length-3));
        let data = muncipality.data;
        let index = 0;
        let selectedMuni = data.find((value: any, index1: number) => {
            if(value.objectId === state.objectId){
                index = index1;
                return value;
            }
        });
        selectedMuni = state;
        selectedMuni.objectId  = state.objectId;
        selectedMuni[documentName] = arr;
        data[index] = selectedMuni;
        const res = await dashboardServices.updateMunicipality(selectedMuni, files);
        if(res.status === 200){
            updateMuncipalityData({
                ...muncipality,
                data: data,
            });
            setState(selectedMuni);
            updateSelectedValues(selectedMuni);
        }
        setLoading(false);
        handleClose();
	};
	const onClose = () => {
		handleClose();
	};
  
	return (
		<Modal open={open} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							padding: '12px 24px',
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted forever</p>
						</div>
					</Stack>

					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						{!isLoading ? (
							<>
								<Button onClick={() => onClose()} variant="outlined">
									Cancel
								</Button>
								<Button onClick={handleDelete} variant="contained">
									Delete
								</Button>
							</>
						) : (
							<LoadingButton
								loading
								loadingIndicator="Deleting..."
								variant="outlined"
							>
								Deleting Data
							</LoadingButton>
						)}
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}
